import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  BD_ZENDESK_BLOCKED_HELP_URL,
  BdUserZendeskService,
} from './zendesk.service';
import { ButtonDirective } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'bd-user-zendesk-button',
  template: `
    <p-toast position="top-right" />
    <button
      pButton
      type="button"
      [disabled]="disabled()"
      class="text-2xl bg-(--app-shell-color)! border-(--app-shell-color)! text-(--app-shell-contrast-color)!"
      (click)="open()"
      [pTooltip]="tooltip()"
      [attr.aria-label]="tooltip()"
      [attr.aria-busy]="loading()"
    >
      <i [class]="iconClass"></i>
    </button>
  `,
  imports: [ButtonDirective, Tooltip, Toast],
  providers: [MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdUserZendeskButtonComponent {
  private readonly _zendeskService = inject(BdUserZendeskService);
  private readonly _messageService = inject(MessageService);

  public readonly disabled = signal(true);
  public readonly loading = signal(true);
  public readonly tooltip = signal('Support wird geladen...');
  public readonly blocked = signal(false);

  public get iconClass(): string {
    return this.loading() ? 'pi pi-spinner pi-spin' : 'pi pi-headphones';
  }

  constructor() {
    this._zendeskService.init().subscribe({
      next: () => {
        this.disabled.set(false);
        this.loading.set(false);
        this.tooltip.set('Support Ticket erstellen');
      },
      error: (err) => {
        this.disabled.set(false);
        this.loading.set(false);
        this.blocked.set(true);
        this.tooltip.set(
          'Browser blockiert das Laden der Support Integration – Klicken für Hilfe',
        );
        console.error('Zendesk initialization failed', err);
      },
    });

    this._zendeskService.ticketSubmitted$.pipe(takeUntilDestroyed()).subscribe(() => {
      this._messageService.add({
        severity: 'success',
        summary: 'Support Ticket',
        detail: 'Support Ticket wurde erfolgreich erstellt',
        life: 5000,
      });
    });
  }

  public open(): void {
    if (this.blocked()) {
      window.open(
        BD_ZENDESK_BLOCKED_HELP_URL,
        '_blank',
        'noopener',
      );
      return;
    }
    this._zendeskService.open();
  }
}
